import type {
  CacheConfig,
  RequestParameters,
  UploadableMap,
  Variables,
} from 'relay-runtime';

import {
  getHeaders,
  getRequestBody,
  handleData,
  isMutation,
} from '@woovi/relay';
import { EventType } from '@woovi/shared';

import fetchWithRetries from './fetchWithRetries.ts';
import pkg from '../../package.json';
import { config } from '../config.tsx';
import { notifyListeners } from '../plugin/notifyListeners.tsx';
import {
  generateSentryTransactionId,
  sentryCaptureExceptionWithScope,
} from '../sentry/sentryFunctions.ts';

export const PLATFORM = {
  APP: 'APP',
  WEB: 'WEB',
};

// Define a function that fetches the results of an request (query/mutation/etc)
// and returns its results as a Promise:
const getFetchQuery =
  (appID: string) =>
  async (
    request: RequestParameters,
    variables: Variables,
    cacheConfig: CacheConfig,
    uploadables: UploadableMap | null,
  ) => {
    const sentryTransactionId = generateSentryTransactionId();

    const body = getRequestBody(request, variables, uploadables);
    const headers = {
      appversion: pkg.version,
      appplatform: PLATFORM.WEB,
      ...getHeaders(uploadables),
      authorization: appID,
      version: 2,
      // https://blog.sentry.io/trace-errors-through-stack-using-unique-identifiers-in-sentry/#2-transmit-the-unique-identifier-as-a-custom-header-and-handle-errors-appropriately
      'X-Sentry-Transaction-ID': sentryTransactionId,
    };

    const isMutationOperation = isMutation(request);

    const fetchFn = isMutationOperation ? fetch : fetchWithRetries;

    const url = config.GRAPHQL_URL;

    try {
      const response = await fetchFn(url, {
        method: 'POST',
        headers,
        credentials: 'include',
        body,
        fetchTimeout: 30000,
        retryDelays: [1000, 3000, 5000, 10000],
      });

      const data = await handleData(response);

      if (response.status === 401) {
        // window.location.replace(routeTo('auth.login'));
        // TODO - show snackbar
        // sink.error(data.errors, false);
        // sink.complete();
        // return;
      }

      if (isMutationOperation && data.errors) {
        throw data;
        // sink.error(data);

        // if (complete) {
        //   sink.complete();
        // }

        // throw data;
      }

      // TODO - improve GraphQL Error handler
      // https://github.com/1stdibs/relay-mock-network-layer/pull/6
      // if (response.status === 200 && Array.isArray(data.errors) && data.errors.length > 0) {
      //   sink.error(data.errors, true);
      //   sink.complete();
      //   return;
      // }

      if (!data.data) {
        sentryCaptureExceptionWithScope({
          requestOperationKind: request.operationKind,
          requestName: request.name,
          sentryTransactionId,
          error: data.errors,
        });

        throw data.errors;
        // sink.error(data.errors);
        // sink.complete();
        // return;
      }

      // sink.next(data);
      // sink.next({
      //   operation: request.operation,
      //   variables,
      //   response: data,
      // });

      // if (complete) {
      //   sink.complete();
      // }

      return data;
      // return {
      //   operation: request.operation,
      //   variables,
      //   response: data,
      // };
    } catch (err) {
      // eslint-disable-next-line
      console.log('err:', err);

      sentryCaptureExceptionWithScope({
        requestOperationKind: request.operationKind,
        requestName: request.name,
        sentryTransactionId,
        error: err,
      });

      // TODO - handle no successfull response after
      const timeoutRegexp = new RegExp(/Still no successful response after/);
      const serverUnavailableRegexp = new RegExp(/Failed to fetch/);

      if (
        timeoutRegexp.test(err?.message) ||
        serverUnavailableRegexp.test(err?.message)
      ) {
        const errorMessage =
          'Serviço indisponível. Tente novamente mais tarde.';

        notifyListeners({
          type: EventType.ON_ERROR,
          data: {
            error: errorMessage,
          },
        });

        throw new Error(errorMessage);
        // sink.error(new Error('Serviço indisponível. Tente novamente mais tarde.'));

        // throw new Error('Serviço indisponível. Tente novamente mais tarde.');
      }

      notifyListeners({
        type: EventType.ON_ERROR,
        data: {
          error: err,
        },
      });

      throw err;
      // sink.error(err);
      // throw err;
    }
  };

export default getFetchQuery;
